module.exports = {"pathContext":{"name":"AppointmentGroup","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"appointments","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"Appointment","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-appointment-group.json
// module id = 1651
// module chunks = 73783555933647